import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';

registerLocaleData(localeIT);

@Pipe({
  name: 's1Currency'
})
export class S1CurrencyPipe extends CurrencyPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): null
  transform(value: number, ...args: unknown[]): string {

    if (args.length > 0 && args[0]) { // se passo true come parametro vuol dire che mi arriva il prezzo in centesimi
      value = value / 100;
    }

    return super.transform(value, 'EUR', 'symbol', '1.2-2', 'it')

  }

}
